import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
  changeModal
} from './actions';
import { throws } from 'assert';

export function* requestOperacaoPreRecebimento({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'prerecebimento', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoPreRecebimento({ payload }) {
  try {
    const { prre_codigo, params } = payload;

    yield call(api.delete, `prerecebimento/${prre_codigo}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaoprerecebimento, params } = payload;

    yield call(api.post, 'prerecebimento', operacaoprerecebimento);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    //history.push('/operacaoabastecimento');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { prre_codigo } = payload;

    const { data } = yield call(api.get, `prerecebimento/${prre_codigo}`);

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaoprerecebimento, params } = payload;

    yield call(api.put, 'prerecebimento', operacaoprerecebimento);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    yield put(changeModal({ closeModal: true }))
    history.push('/prerecebimento');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'prerecebimento', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaoprerecebimento/PRERECEBIMENTO_IN_REQUEST',
    requestOperacaoPreRecebimento
  ),
  takeLatest(
    '@operacaoprerecebimento/DELETE_PRERECEBIMENTO',
    deleteOperacaoPreRecebimento
  ),
  takeLatest(
    '@operacaoprerecebimento/SUCCESS_REMOVE',
    requestOperacaoPreRecebimento
  ),
  takeLatest('@operacaoprerecebimento/STORE_PRERECEBIMENTO', store),
  takeLatest('@operacaoprerecebimento/FIND_PRERECEBIMENTO', find),
  takeLatest('@operacaoprerecebimento/UPDATE_PRERECEBIMENTO', update),
  takeLatest('@operacaoprerecebimento/RECORD_FILTERING', applyedFilters),
]);
